import { useMemo } from "react"
import { Stack } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { useAppLocalization } from "../../../../../../localization/components/AppLocalizationProvider"
import { MeetingDetailsOrder } from "../../../../../../nonAdminUser/reports/home/meetingServiceApi"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { useDateTime } from "../../../../../../localization/useDateTime"
import { DeliveryType } from "../../meetingServiceTypes"
import DetailRow from "./DetailRow"

const useStyles = makeStyles()((theme) => ({
    sectionTitle: {
        fontWeight: 600,
        color: theme.palette.tailwind.slate[900],
        marginBottom: theme.spacing(2),
    },
    deliveryDetailsContainer: {
        marginTop: theme.spacing(2),
    },
}))

interface DeliveryDetailsProps {
    order: MeetingDetailsOrder
}

export default function DeliveryDetails({ order }: DeliveryDetailsProps) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()
    const { l10n } = useAppLocalization()

    const meetingTimeStart = dateTimeFactory.fromApi(order.meetingDetails?.startDateTime)
    const meetingTimeEnd = dateTimeFactory.fromApi(order.meetingDetails?.endDateTime)

    const deliveryLocation = useMemo(() => {
        const deliveryType = order.deliveryDetails.type

        if (deliveryType === DeliveryType.EATING_IN_CANTEEN || deliveryType === DeliveryType.PICK_UP) {
            return l10n.getStringForEnum("delivery-type-filter", deliveryType, deliveryType)
        }

        return order.deliveryDetails?.location?.name ?? "-"
    }, [order, l10n])

    return (
        <Stack gap="0.5rem" className={classes.deliveryDetailsContainer}>
            <LocalizedStrict id="meeting-service-delivery-list-delivery-details-meeting-time" attrs={{ label: true }}>
                <DetailRow
                    label="Meeting time:"
                    value={
                        meetingTimeStart.isValid && meetingTimeEnd.isValid
                            ? dateTimeFactory.formatPeriod(meetingTimeStart, meetingTimeEnd)
                            : "-"
                    }
                />
            </LocalizedStrict>
            <LocalizedStrict id="meeting-service-delivery-list-delivery-details-location" attrs={{ label: true }}>
                <DetailRow label="Delivery location:" value={deliveryLocation} />
            </LocalizedStrict>
            <LocalizedStrict id="meeting-service-delivery-list-delivery-details-sittings" attrs={{ label: true }}>
                <DetailRow label="Sittings:" value={order.deliveryDetails.sittings ?? "-"} />
            </LocalizedStrict>
        </Stack>
    )
}
